"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirstAndLastName = void 0;
/**
 * 
 * @param {*} name 
 */
var getFirstAndLastName = exports.getFirstAndLastName = function getFirstAndLastName(name) {
  var trimmedName = name.trim();
  var firstname = trimmedName.split(' ').slice(0, -1).join(' ');
  var lastname = trimmedName.split(' ').slice(-1).join(' ');
  return {
    firstname: firstname,
    lastname: lastname
  };
};